import React, { useEffect, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Drawer, InputLabel, IconButton, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useDispatch, useSelector } from 'react-redux';
import { UserPortalContext } from 'context/appcontext';
import PropTypes from 'prop-types';
import moment from 'moment';
import dashboardStyles from '../Dashboard.style';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import CloseIcon from '@material-ui/icons/Close';
import {
	getSchedule,
	formatBytes,
	getTmplName,
	getSavedCustomDatasetWithAttributes,
	getDfltFilter,
	isCustomDataset
} from 'helper/utils';
import { getAuthHeader } from 'helper/authHeader';
import {
	downloadReport,
	downloadLargeReport,
	editReport,
	initiateRunNow
} from '../Dashboard.actions';
import BouncingLoader from './BouncingDots/BouncingLoader';
import MoreOptions from './MoreOptions';
import {
	setSelectedTemplate,
	getTempatesSuccess,
	getTempatesFailure,
	getCustomAttributeSuccess,
	getCustomAttributeFailure,
	setCustomDatasetName,
	getCannedReportsSuccess
} from 'components/Template/Template.actions';
import { getSelectedList as fetchSelectedList } from '../report-list/utils/report';
import {
	setSelectedList,
	setPrevSelectedList,
	setPrevFilterList,
	setFilterList,
	getRowCount,
	loadPreviewData,
	setMenu,
	saveItemShareStatus
} from 'components/Preview/Preview.actions';
import APIURLPATH from 'constants/apiconstants';
import {
	REPORT_INFO,
	DOWNLOAD,
	DOWNLOAD_AGAIN,
	EDIT,
	MAX_ROW_COUNT,
	CSV_FILE_TYPE,
	SHARED,
	CREATE_COPY,
	DT_DIM_EX_CUSTOM,
	CANNED_REPORT_LIST,
	MAX_FILTER_VALUE_TO_BE_SHOWN,
	VIEW_ALL,
	VIEW_LESS,
	BASIC,
	CHARTER_DELETE_MSG,
	BASIC_DELETE_MSG,
	ITEM_SHARE,
	PERSONA,
	FILTER_CONDITION_LABELS,
	PREVIEW_READY_CREATE_REPORT,
	REPORT,
	ALL_LINK_ROLLUP,
	ALL_LINK_ROLL_DETAIL,
	LINKED_ITEM_ACTIVITY,
	STR_DEMAND_LIST,
	MTS_COLUMN_TITLE,
	PROJECTS,
	MULTI_TIME_SELECTION,
	WALMART_CALENDAR,
	CUSTOM,
	CATMAN_CUSTOM_DATASET_IDS,
	RUNNING,
	SCHEDULED,
	COMPLETED,
	NOW,
	LATER,
	TODAY,
	PREVIEW_LOADING_MSG,
	NETWORK_ISSUE_MSG,
	NEXT_EXECUTION_TIME,
	ALL_CDS_IDS,
	TIME_ACROSS_DATA_DOWN,
	TIME_FRAME_IN_ROW,
	GENERAL_CANNED_REPORT_LIST
} from 'constants/constant';
import { deepClone, getFullPersona } from 'helper/helper';
import ErrorOccurred from '../../Shared/ErrorOccurred';
import { trackEventInfo } from 'helper/analytics';
import { EVENTS, PAGE_ID, ACTION_ON } from 'constants/tracker';
import {
	buildBusinessName,
	getUpdatedFilters,
	getSelectedView,
	updateDtObj,
	hasPivotedColumn
} from 'components/Preview/Preview.utils';
import { isMultiWeekSel } from 'components/Preview/filter/FilterCondition';
import { selectedTempDetials } from '../report-list/utils/dashboard-utils';
import RBButton from '../../Shared/RBButton';
import {
	draftPrevSelectedList,
	draftPrevFilterList,
	draftPrevPivotOption,
	saveDraftSuccess
} from 'components/Preview/Preview.actions';
import { build } from 'helper/build';
import RBSnackbar from 'components/Shared/RBSnackbar';
import ItemShareTnCDialog from '../../Shared/ItemShareTnCDialog';

const MetaData = (props) => {
	const navigate = useNavigate();
	const { show, setShow, data } = props;
	const isItemShare = data?.runQueryRequestObject?.itemShare;
	const dispatch = useDispatch();
	const isSmallScreen = useMediaQuery('(max-width:360px)');
	const classes = dashboardStyles();
	const portalUserContext = useContext(UserPortalContext);
	const { userDetails, updateUserPersona, customerType, isItemShareAccepted } = portalUserContext;
	const { companyName, loginId, catManUser, blackOut, userPersona } = userDetails?.result;
	const [open, setOpen] = useState(null);
	const [expanded, setExpanded] = useState(false);
	const [openTnC, setOpenTnC] = useState({ open: false, clickOn: '' });

	const templateData = useSelector((state) => state.templateReducer.templateData);
	const cannedReportData = useSelector((state) => state.templateReducer.cannedReportData);
	const isEditEnabled = useSelector((state) => state.dashboardReducer.isEditEnabled);
	const tabValue = useSelector((state) => state.dashboardReducer.tabValue);
	const reportTypeTabValue = useSelector((state) => state.dashboardReducer.reportTypeTabValue);
	const sbuDBTechNames = useSelector((state) => state.templateReducer.sbuDimDBTechName);
	const sbuDepartments = useSelector((state) => state.templateReducer.sbuDepartments);
	const selectedView = useSelector((state) => state.templateReducer.selectedView);
	const sharedReportTabValue = useSelector((state) => state.dashboardReducer.sharedReportTabValue);
	const savedCustomDatasets = useSelector((state) => state.templateReducer.savedCustomDatasets);
	const customDatasetDetails = useSelector((state) => state.templateReducer.customDatasetDetails);
	const customAttribute = useSelector((state) => state.templateReducer.customAttribute);
	const [openSnackbar, setSnackbar] = useState({ open: false, msg: '' });
	const reportFooterButtons = ['download', 'edit'];
	const draftFooterButtons = ['edit'];
	const { SUPPLIER, CATMAN } = PERSONA;

	useEffect(() => {
		return isSmallScreen && setShow(false);
	}, [isSmallScreen]);

	const handleBack = () => {
		setShow(false);
	};

	const skipTour = () => {
		localStorage.setItem('PreviewComponentTourSkip', true);
		localStorage.setItem('PreviewElementTourSkip', true);
		localStorage.setItem('FilterFormTourSkip', true);
	};

	const handleEdit = () => {
		// Analytics
		trackEventInfo({
			type: EVENTS.CLICK,
			actionOn:
				reportTypeTabValue === 0
					? `${ACTION_ON.EDIT_REPORT_BUTTON} ${data?.templateName}`
					: `${ACTION_ON.EDIT_DRAFT} ${data?.templateName}`,
			location: PAGE_ID.DASHBOARD_METADATA
		});

		setSnackbar({
			open: true,
			msg: PREVIEW_LOADING_MSG,
			type: 'success',
			hideDuration: 5000
		});

		navigateToPreview();
		skipTour();
	};

	const navigateToPreview = async () => {
		let templateId = undefined;
		let selectedTemp = undefined;

		if (userPersona === CATMAN && data.reportType === SUPPLIER) {
			const isCannedReport = GENERAL_CANNED_REPORT_LIST.includes(Number(data.templateId));
			let url = isCannedReport
				? `${APIURLPATH.CANNED_TEMPLATES}SUPPLIER`
				: `${APIURLPATH.VIEW_TYPE}SUPPLIER`;
			let customUrl = `${APIURLPATH.CUSTOM_ATTRIBUTES_TYPE}SUPPLIER`;

			const request = { companyName, loginId };
			const { headers } = getAuthHeader(request);
			try {
				const response = await fetch(url, {
					method: 'GET',
					headers: {
						...headers
					}
				});
				const customResponse = await fetch(customUrl, {
					method: 'GET',
					headers: {
						...headers
					}
				});

				if (response?.status >= 400 || customResponse?.status >= 400) {
					setSnackbar({
						open: true,
						msg: NETWORK_ISSUE_MSG,
						type: 'error',
						hideDuration: 5000
					});
					return;
				} else {
					let res = await response?.json();
					let customRes = await customResponse?.json();
					updateUserPersona(data.reportType);
					if (isCannedReport) {
						dispatch(getCannedReportsSuccess(res));
					} else {
						dispatch(getCustomAttributeSuccess(customRes));
						dispatch(getTempatesSuccess(res));
					}
					dispatch(getCustomAttributeSuccess(customRes));
					dispatch(getTempatesSuccess(res));
					res = res.map((item) => {
						if (isCannedReport) {
							return item;
						}
						return {
							...item,
							customAttribute: customRes
						};
					});
					nextSteps(res);
				}
			} catch (error) {
				dispatch(getTempatesFailure(505));
				dispatch(getCustomAttributeFailure(505));
			}
		} else {
			nextSteps(templateData);
		}

		function nextSteps(tempData) {
			const _isItemShare = data.runQueryRequestObject.itemShare || false;

			const savedCustomDatasetWithAttributes = getSavedCustomDatasetWithAttributes(
				savedCustomDatasets,
				customDatasetDetails,
				customAttribute
			);
			const tmpData = [...cannedReportData, ...tempData, ...savedCustomDatasetWithAttributes];
			const potentialTempList = tmpData.filter((item) => {
				const isCatmanCustomDS =
					CATMAN_CUSTOM_DATASET_IDS.includes(Number(data.templateId)) && userPersona === CATMAN;
				if (isCatmanCustomDS || data.templateId === customDatasetDetails.templateId) {
					return data?.customDatasetId === item?.customDatasetId;
				} else {
					return item.templateName === data.templateName;
				}
			});
			const tempWithSameId = potentialTempList.find((temp) => temp.templateId === data.templateId);
			selectedTemp = tempWithSameId ? tempWithSameId : potentialTempList[0];
			dispatch(setCustomDatasetName({ datasetName: selectedTemp.customDatasetName }));

			templateId = selectedTemp?.templateId;

			let appliedFilter = data?.filtersWithValue.filter((item) => {
				// In MTS, there is a chance that the condition is empty but the custom dates are filled, in this case,
				// we would want the filter
				if (item?.localName === MULTI_TIME_SELECTION) {
					return true;
				}
				return item.filter.condition !== '';
			});

			/**
			 * if template is demand forecast
			 * find isCalObj and store in diff variable (say _o)
			 * filter appliedFilter and remove isCalObj
			 * Update - field and filter object - call getLastXWkRange
			 * pushing _o in appliedFilter
			 */

			if (STR_DEMAND_LIST.includes(Number(templateId))) {
				appliedFilter = updateDtObj(appliedFilter);
			}

			if (tabValue === SHARED && data?.reportType !== userPersona) {
				appliedFilter = getUpdatedFilters(appliedFilter, templateId, selectedTemp, userPersona);
			}

			if (userPersona === 'MERCHANT' && !blackOut) {
				if (!appliedFilter.find((item) => sbuDBTechNames.includes(item.dbtechnicalName))) {
					const SBUdimension = selectedTemp.dimensions.filter((dim) =>
						sbuDBTechNames.includes(dim.dbtechnicalName)
					);

					const SBUDfltCondition = FILTER_CONDITION_LABELS.IS_EQUAL_TO;

					const dfltFiltersOnDimensions = [];
					SBUdimension.map((dim) => {
						dfltFiltersOnDimensions.push({
							dimension: dim,
							condition: SBUDfltCondition,
							value: sbuDepartments.map((dept) => dept.deptNum)
						});
					});
					const defaultFilterSel = getDfltFilter(templateData, dfltFiltersOnDimensions);

					defaultFilterSel.map((filter, index) => {
						if (sbuDBTechNames.includes(filter.dbtechnicalName)) {
							const field = build(defaultFilterSel[index], selectedView, userPersona);
							defaultFilterSel[index] = { ...defaultFilterSel[index], field };
							appliedFilter.push(defaultFilterSel[index]);
						}
					});
				}
			}

			const selectedList = fetchSelectedList(data, tmpData, templateId);
			const req = deepClone(data.runQueryRequestObject);

			if (data?.pivotColumn && hasPivotedColumn(data?.pivotColumn)) {
				/**
				 * In the case of Pivot on Walmart Calendar Week,
				 * if it has no MTS filter applied, the pivot value should be changed to appropriate technicalName
				 */
				const wmtCalWeeks = ['walmart_calendar_week', 'walmart_year_and_week'];
				const weekFilterApplied = data?.filtersWithValue?.find(
					(e) => wmtCalWeeks.includes(e?.technicalName) && e?.parent === WALMART_CALENDAR
				);
				if (weekFilterApplied) {
					// data.pivotColumn = isMTS(weekFilterApplied)
					// 	? data.pivotColumn
					// 	: weekFilterApplied?.technicalName;

					data.isMultiWeek = isMultiWeekSel(weekFilterApplied, Number(data.templateId));
				}
			}
			/* Dispatch all actions */
			dispatch(
				loadPreviewData({
					requestBody: req,
					editData: data
				})
			);
			let updatedSelectedView = data.runQueryRequestObject.view;
			if (tabValue === SHARED && data?.reportType !== userPersona) {
				updatedSelectedView = getSelectedView(appliedFilter, templateId, selectedTemp);
			}
			dispatch(setSelectedTemplate(selectedTempDetials(updatedSelectedView, selectedTemp)));
			dispatch(editReport({ isEditEnabled: true, editData: data, action: 'EDIT' }));

			dispatch(setSelectedList(selectedList));
			dispatch(setPrevSelectedList(selectedList));
			dispatch(setFilterList(appliedFilter));
			dispatch(
				setPrevFilterList(
					data?.filtersWithValue.filter((item) => {
						// In MTS, there is a chance that the condition is empty but the custom dates are filled, in this case,
						// we would want the filter
						if (item?.localName === MULTI_TIME_SELECTION) {
							return true;
						}
						return item.filter.condition !== '';
					})
				)
			);

			/** for save draft  - If edit called from meta data*/
			if (data?.draftName) {
				dispatch(draftPrevSelectedList(selectedList));
				dispatch(draftPrevFilterList(data?.filtersWithValue));
				dispatch(draftPrevPivotOption(data?.pivotColumn));
				dispatch(saveDraftSuccess(data));
				dispatch(setMenu(undefined));
			}
			dispatch(saveItemShareStatus({ prev: _isItemShare, curr: _isItemShare }));
			dispatch(getTempatesSuccess(tmpData));
			navigate('/preview');
		}
	};

	const handleCreateReport = (rowData) => {
		const { runQueryRequestObject, templateId, filtersWithValue } = rowData;
		const allData = [...templateData, ...cannedReportData];
		const selectedTemp = allData?.filter(
			(item) => item.templateName === getTmplName(rowData?.templateId)
		);

		const selectedList = fetchSelectedList(rowData, selectedTemp, templateId);
		dispatch(setSelectedList(selectedList));
		dispatch(setFilterList(filtersWithValue));
		dispatch(
			setSelectedTemplate(selectedTempDetials(rowData.runQueryRequestObject.view, selectedTemp))
		);
		dispatch(editReport({ isEditEnabled: true, editData: rowData, action: 'CREATE' }));
		dispatch(setMenu(undefined));

		/** this is to remove parent_cmpny_nm and pass luminate_cmpny_id
		 * but not for VSC
		 */
		const queryObj = deepClone(runQueryRequestObject);
		for (const key in queryObj.filters) {
			const [tbleName, colName] = key.split('.');
			const isVSC = CANNED_REPORT_LIST.includes(Number(rowData?.templateId));
			if (colName === 'parent_cmpny_nm') {
				let compyName = 'luminate_cmpny_id';
				if (isVSC) {
					compyName = 'parent_cmpny_nm';
				}
				const parentAttr = `${tbleName}.${compyName}`;
				queryObj.filters[parentAttr] = 'COMPANYNAME';
				if (!isVSC) {
					delete queryObj.filters[key];
				}

				break;
			}
		}

		// Analytics
		trackEventInfo({
			type: EVENTS.CLICK,
			actionOn: `${ACTION_ON.CRETE_REPORT_FROM_DRAFT} ${data?.templateName}`,
			location: PAGE_ID.DASHBOARD_METADATA
		});

		dispatch(
			getRowCount({
				requestBody: queryObj,
				companyName,
				templateId: templateId
			})
		);
		navigate({
			pathname: '/reports',
			search: '?quick=true'
		});
	};

	const parsedData = (param) => {
		const filters = [];
		const dateFormat = 'MM/DD/YYYY HH:mm';
		const freq = param?.frequency;
		let appliedFilter = deepClone(param?.filtersWithValue);
		const isCustomDS = isCustomDataset(param?.customDatasetId);
		// getUpdatedFilters is failing for shared CDS reports from Catman to supplier, therefore add the customDataset check to
		// make sure this "if" clause is not run in the case of CDS.
		if (tabValue === SHARED && data?.reportType !== userPersona && !isCustomDS) {
			const savedCustomDatasetWithAttributes = getSavedCustomDatasetWithAttributes(
				savedCustomDatasets,
				customDatasetDetails,
				customAttribute
			);
			const allData = [...templateData, ...cannedReportData, ...savedCustomDatasetWithAttributes];
			const isCustomDSReport =
				param?.templateId === customDatasetDetails?.templateId ||
				CATMAN_CUSTOM_DATASET_IDS.includes(param?.templateId) ||
				param?.customDatasetId?.length > 0;
			const selectedTemp = allData.filter((item) => {
				if (isCustomDSReport) {
					return item?.customDatasetId === param?.customDatasetId;
				} else {
					return item.templateName === param.templateName;
				}
			})[0];
			const templateId = selectedTemp ? selectedTemp.templateId : data?.templateId;
			appliedFilter = getUpdatedFilters(
				param?.filtersWithValue,
				templateId,
				selectedTemp,
				userPersona
			);
		}

		let linkItemActivityName = '';
		if (param?.linkItemActivity?.length > 0) {
			if (param.linkItemActivity === 'allLinkRollUp') {
				linkItemActivityName = ALL_LINK_ROLLUP;
			}
			if (param.linkItemActivity === 'allLinkRollDetails') {
				linkItemActivityName = ALL_LINK_ROLL_DETAIL;
			}
		}

		if (linkItemActivityName.length > 0) {
			filters.push({
				bussName: LINKED_ITEM_ACTIVITY,
				condition: '',
				parent: '',
				value: linkItemActivityName
			});
		}

		appliedFilter?.forEach((item) => {
			if (item.field !== undefined) {
				const obj = {};
				obj.bussName = item.businessName;
				obj.condition = item.filter?.condition;
				obj.parent = item.parent;
				if (item.dataType === 'date') {
					if (!['Now', 'Today'].includes(freq)) {
						obj.value = '';
					} else if (item.filter.condition !== CUSTOM) {
						if (isMultiWeekSel(item, Number(data.templateId))) {
							obj.value = '';
						} else if (
							DT_DIM_EX_CUSTOM.includes(item.filter.condition) ||
							(['dimensions', 'measures'].includes(item.parent) && item.dataType === 'date')
						) {
							obj.value = item.filter?.value[0];
						} else {
							obj.value = item.filter?.extraValue?.join('-');
						}
					} else {
						obj.value = item.filter.value.join('-');
					}
				} else {
					if (item.filter.condition === 'is in between') {
						obj.value = item.filter.value.join('-');
					} else {
						obj.value = item.filter.value.join(',');
					}
				}
				obj.value = obj.value.length > 0 ? `: ${obj.value}` : ``;
				filters.push(obj);

				// If it is MTS, then there's a chance that we might have usual conditions and also custom dates
				if (item?.localName === MULTI_TIME_SELECTION) {
					let value = '';
					const customDateOne = item?.mts?.CUSTOM_DATE_1;
					const customDateTwo = item?.mts?.CUSTOM_DATE_2;
					if (customDateOne) {
						const start = moment(customDateOne?.date?.startDateString).format('YYYY-MM-DD');
						const end = moment(customDateOne?.date?.endDateString).format('YYYY-MM-DD');
						value = `: ${start} - ${end}`;
					}
					if (customDateTwo) {
						const start = moment(customDateTwo?.date?.startDateString).format('YYYY-MM-DD');
						const end = moment(customDateTwo?.date?.endDateString).format('YYYY-MM-DD');
						value = `${value}, ${start} - ${end}`;
					}
					if (customDateOne || customDateTwo) {
						const newObj = {
							bussName: item.businessName,
							condition: CUSTOM,
							parent: item?.parent,
							value: value
						};
						filters.push(newObj);
					}
					/**
					 * Set flag isMultiTimeSelection = true for MTS filters, which is used to show the appropriate Label
					 */
					filters.forEach((el) => {
						if (el?.parent === WALMART_CALENDAR) {
							el.isMultiTimeSelection = true;
						}
					});
				}
			}
		});

		const buildFiltersForMetadata = () => {
			const styledFilters = filters.map((el) => {
				/**
				 * Hardcoded value = MAX_FILTER_VALUE_TO_BE_SHOWN to max characters to be shown in non-expanded filter values in metadata panel
				 */

				const isLenExtended = el.condition.length + el.value.length > MAX_FILTER_VALUE_TO_BE_SHOWN;

				const conditionValue =
					expanded || !isLenExtended
						? el.value
						: `${el.value.substring(0, MAX_FILTER_VALUE_TO_BE_SHOWN - el.condition.length)}... `;

				/**
				 * Need to parent if label is week, quarter or year
				 */

				let appendParent = '';

				if (['Week', 'Quarter', 'Year'].includes(el.bussName)) {
					appendParent = ` (${el.parent})`;
				}

				if (el?.condition === '') {
					return null;
				}

				// In the case of MTS, there is a chance there might be both custom dates and
				// fuzzy options in which case we would only need one heading for both
				let showHeading = true;
				if (el?.condition === CUSTOM) {
					// if another filter which is not custom is present for walmart calendar, then dont
					// show the heading for custom
					const index = filters?.findIndex(
						(filter) =>
							filter?.parent === WALMART_CALENDAR &&
							filter?.condition !== '' &&
							filter?.condition !== CUSTOM
					);
					if (index > -1) {
						showHeading = false;
					}
				}

				let filterHeading = showHeading
					? buildBusinessName(el.bussName, param?.templateId) + appendParent
					: '';
				if (el?.isMultiTimeSelection && showHeading) {
					filterHeading = MTS_COLUMN_TITLE;
				}

				return (
					<Box key={el.bussName} className={classes.metadataFilters}>
						{showHeading && (
							<InputLabel className={classes.metadataFilterBussName}>{filterHeading}</InputLabel>
						)}
						<InputLabel
							className={`${
								expanded ? classes.metadataFilterExpanded : classes.metadataFilterConditionValue
							}`}>
							{el.condition.length > 0 && (
								<span className={classes.metadataFilterCondition}>{el.condition}</span>
							)}
							<span>{conditionValue}</span>
							{isLenExtended && !expanded && (
								<span
									className={classes.metadataFilterShowBtn}
									onClick={() => {
										setExpanded(true);
									}}>
									{VIEW_ALL}
								</span>
							)}
						</InputLabel>
						{isLenExtended && expanded && (
							<span
								className={classes.metadataFilterShowBtn}
								onClick={() => {
									setExpanded(false);
								}}>
								{VIEW_LESS}
							</span>
						)}
					</Box>
				);
			});
			return styledFilters;
		};

		const printSelectedAttr = () => {
			let selectedList = deepClone(param?.columns);
			let _tmplt = param.templateId;
			// Note: If it is a shared CDS, then the current user viewing the report doesn't have access to the
			// original CDS that was created by the other user. In this case, directly take all the columns and combine them
			// instead of looking for the template from which it was created.
			if (
				!ALL_CDS_IDS.includes(Number(_tmplt)) &&
				tabValue === SHARED &&
				param?.reportType !== userPersona
			) {
				const selectedTemp = templateData.filter(
					(item) => item.templateName === param.templateName
				)[0];
				_tmplt = selectedTemp ? selectedTemp.templateId : param.templateId;
				const tmpData = CANNED_REPORT_LIST.includes(Number(_tmplt))
					? cannedReportData
					: templateData;
				selectedList = fetchSelectedList(param, tmpData, _tmplt).map((el) => el.businessName);
			}

			const _retList = selectedList.map((el) => buildBusinessName(el, _tmplt));
			return _retList.join(' | ');
		};
		const executionTimeKey =
			!param?.isRunAfterRefresh || [NOW, LATER, TODAY].includes(param?.frequency)
				? NEXT_EXECUTION_TIME
				: 'Estimated next execution time';

		// Pivot field & data
		let format = undefined;
		if (data?.pivotColumn) {
			format = hasPivotedColumn(data?.pivotColumn) ? TIME_ACROSS_DATA_DOWN : TIME_FRAME_IN_ROW;
		}

		return {
			'Report Id': param.reportId || param.draftId,
			Name: param.reportName || param.draftName,
			Description: param.reportDesc && (
				<span style={{ whiteSpace: 'pre-line' }}>{param.reportDesc}</span>
			),
			'Report Type': catManUser ? param.reportType && getFullPersona(param.reportType) : null,
			Dataset: param.templateName,
			format,
			Columns: printSelectedAttr(),
			Filters: buildFiltersForMetadata(),
			'File Type': param.fileType,
			'File Size': param.fileSize && formatBytes(Number(param.fileSize)),
			Schedule: getSchedule(param.cronExpression, param.frequency, param.scheduleStartDate),
			'Last execution time':
				param.lastRunDate && moment.utc(param.lastRunDate).local().format(dateFormat),
			[executionTimeKey]:
				param.nextRunDate && moment.utc(param.nextRunDate).local().format(dateFormat),
			'Report End Date': param.purgeDate && moment.utc(param.purgeDate).local().format(dateFormat),
			Remark: param.remarks
		};
	};

	const toggleDrawer = () => () => {
		setShow(false);
		setOpen(null);
	};

	const handleDownload = (param) => {
		const { reportId, fileUrl, rowCount, fileType } = param;
		const downloadRequest = { reportId, fileUrl };

		trackEventInfo({
			type: EVENTS.CLICK,
			actionOn: ACTION_ON.DOWNLOAD_BUTTON,
			location: PAGE_ID.DASHBOARD_METADATA
		});
		dispatch(
			downloadReport({ requestBody: downloadRequest, companyName, loginId, rowCount, fileType })
		);
		if (rowCount > MAX_ROW_COUNT && fileType.toUpperCase() === CSV_FILE_TYPE) {
			dispatch(
				downloadLargeReport({
					requestBody: downloadRequest,
					companyName,
					loginId,
					rowCount,
					fileType
				})
			);
		}

		/**
		 * We need to update the downloadCount of param itself which will update the count in MobileTable and CustomTable
		 * so that we can display appropriate option lable from DOWNLOAD and DOWNLOAD AGAIN
		 * */
		param.downloadCount = param.downloadCount + 1;
	};

	const checkEdit = () => {
		// If the template id of the reoprt matches with any custom dataset ids, then it is a CDS report.
		const isCustomDSReport =
			Number(data?.templateId) === Number(customDatasetDetails?.templateId) ||
			ALL_CDS_IDS.includes(Number(data?.templateId));
		const isReportFromUnsavedCDS = (data?.customDatasetId?.length ?? 0) === 0;

		// If the report is created from an unsaved custom dataset, then disable "create a copy", "edit", etc.
		if (isCustomDSReport && isReportFromUnsavedCDS) {
			return true;
		}

		// If the report is created from any custom dataset and it is a "shared" report, then disable "create a copy", "edit", etc.
		if (isCustomDSReport && tabValue === SHARED) {
			return true;
		}

		if (tabValue === PROJECTS) {
			if (moment(data?.scheduleEndDate).isBefore(moment())) {
				return true;
			}
			if (data?.status === RUNNING || data?.runQueryRequestObject === null) {
				return true;
			}
			if (data?.status === SCHEDULED && data?.frequency === NOW) {
				return true;
			}
		}
		return false;
	};

	const handleRunNow = () => {
		dispatch(initiateRunNow({ requestBody: data.reportId, companyName }));
	};

	const getLabel = (key) => {
		/**
		 * For canned reports, metadata should show label as METRICS instead of COLUMNS
		 */
		if (key === 'Columns' && CANNED_REPORT_LIST.includes(Number(data?.templateId))) {
			return 'METRICS';
		}
		return key.toUpperCase();
	};

	const getBtnLabel = () => {
		if (tabValue === SHARED) {
			if (sharedReportTabValue === 1) {
				return `${EDIT} & ${REPORT.toLowerCase()}`;
			}
			return CREATE_COPY;
		}
		if (reportTypeTabValue === 0) {
			return EDIT;
		}
		return `${EDIT} & ${PREVIEW_READY_CREATE_REPORT}`;
	};

	const buttonProps = (id) => {
		const props = {
			edit: {
				id: 'edit',
				cbHandleClick: () => {
					if (
						tabValue === SHARED &&
						!isItemShareAccepted &&
						data.runQueryRequestObject?.itemShare
					) {
						setOpenTnC({ open: true, clickOn: 'EDIT' });
						return;
					}
					handleEdit();
				},
				disabled: checkEdit(),
				btnName: (
					<span style={{ display: 'flex', alignItems: 'center' }}>
						{getBtnLabel()}
						{isEditEnabled && <BouncingLoader />}
					</span>
				),
				type: 'secondary'
			},
			create: {
				id: 'craete-button',
				cbHandleClick: () => {
					handleCreateReport(data);
				},
				btnName: 'Create Report',
				type: 'primary'
			},
			download: {
				id: 'drawer-download-button',
				cbHandleClick: () => {
					if (
						tabValue === SHARED &&
						!isItemShareAccepted &&
						data.runQueryRequestObject?.itemShare
					) {
						setOpenTnC({ open: true, clickOn: 'DOWNLOAD' });
						return;
					}
					handleDownload(data);
				},
				disabled:
					(tabValue === SHARED && data?.sharedWith?.isDataIncluded === false) ||
					data?.status !== COMPLETED,
				btnName:
					tabValue === SHARED || [null, 0].includes(data?.downloadCount)
						? DOWNLOAD
						: DOWNLOAD_AGAIN,
				type: 'primary'
			}
		};
		return props[id];
	};

	const footerMenuList = () => {
		if (data?.draftName || (tabValue === SHARED && sharedReportTabValue === 1)) {
			return draftFooterButtons;
		}
		return reportFooterButtons;
	};

	return (
		<Box>
			<Drawer
				variant="temporary"
				anchor="right"
				open={show}
				id={'template-drawer'}
				onClose={toggleDrawer()}>
				<Box className={classes.drawerContainer}>
					<Box className={classes.drawerContent}>
						<Box id="insghts-detail" className={classes.darwer}>
							<Box id="insghts-detail" className={classes.smallScreen}>
								{isSmallScreen && (
									<IconButton
										id="dashboard-back"
										aria-label="back-button"
										size="medium"
										onClick={handleBack}
										className={classes.backButton}>
										<ArrowBackIosIcon fontSize="inherit" />
									</IconButton>
								)}
								<InputLabel className={classes.drawerTitle}>{REPORT_INFO}</InputLabel>
							</Box>
							{!isSmallScreen && (
								<>
									{tabValue !== SHARED && reportTypeTabValue === 0 && (
										<>
											<IconButton
												id="metadata-more"
												aria-label="metadata-more"
												size="medium"
												onClick={(e) => {
													setOpen(e.currentTarget);
												}}
												className={classes.crossButton}>
												<MoreVertIcon fontSize="inherit" />
											</IconButton>
											<MoreOptions
												open={open}
												setOpen={setOpen}
												handleRunNow={handleRunNow}
												data={data}
												// checkRunNow={checkRunNow}
											/>
										</>
									)}
									<IconButton
										id="dashboard-close"
										aria-label="close-button"
										size="medium"
										onClick={handleBack}
										className={classes.crossButton}>
										<CloseIcon fontSize="inherit" />
									</IconButton>
								</>
							)}
						</Box>
					</Box>
					{data?.status === 'FAILED' && <ErrorOccurred />}
					{data?.status !== 'FAILED' && data?.purgeDate && (
						<Box id="delete-report-after-days" className={classes.deleteReport}>
							{customerType === BASIC ? BASIC_DELETE_MSG : CHARTER_DELETE_MSG}
						</Box>
					)}
					{isItemShare && (
						<Alert severity="error" className={classes.itemShareMsg}>
							<Typography
								style={{ fontWeight: 400, fontSize: 14, color: '#13014A' }}
								id="item_share-msg">
								{ITEM_SHARE.META_DATA_MSG}
							</Typography>
						</Alert>
					)}
					<Box className={classes.drawerContent} style={{ height: 'calc(100vh - 225px)' }}>
						{data &&
							Object.keys(parsedData(data)).map(function (key) {
								if (
									data.frequency &&
									[NOW, LATER, TODAY].includes(data.frequency) &&
									key === NEXT_EXECUTION_TIME
								) {
									return;
								}
								return (
									parsedData(data)[key] && (
										<Box key={key} className={classes.detail}>
											<InputLabel className={classes.key}>{getLabel(key)}</InputLabel>
											<InputLabel className={classes.value}>{parsedData(data)[key]}</InputLabel>
										</Box>
									)
								);
							})}
					</Box>
				</Box>
				<Box className={classes.buttonContainer}>
					{footerMenuList().map((item, id) => {
						return <RBButton {...buttonProps(item)} key={id} />;
					})}
				</Box>
			</Drawer>
			<RBSnackbar
				doOpen={openSnackbar.open}
				msg={openSnackbar.msg}
				doClose={() => {
					setSnackbar({ open: false, msg: '' });
				}}
				type={openSnackbar.type}
			/>
			<ItemShareTnCDialog
				open={openTnC.open}
				onClose={({ status, otherProps }) => {
					setOpenTnC(false);
					if (status === 'ACCEPTED') {
						if (otherProps === 'EDIT') {
							handleEdit();
						}

						if (otherProps === 'DOWNLOAD') {
							handleDownload(data);
						}
					}
				}}
				otherProps={openTnC.clickOn}
			/>
		</Box>
	);
};

MetaData.propTypes = {
	setShow: PropTypes.func.isRequired,
	show: PropTypes.bool.isRequired
};

export default MetaData;
